module.exports = __webpack_public_path__ + "static/teck_2-9f387217e7ac1c8a029c071614b94cd5.jpg";